import PropTypes from 'prop-types'
import { Link as RouterLink } from 'react-router-dom'
import { Box } from '@mui/material'

export default function Logo({ sx }) {
  return (
    <RouterLink to='/'>
      <Box
        style={{ marginBottom: 20 }}
        component='img'
        src='/static/new-logo.png'
        sx={{ width: 70, height: 70, ...sx }}
      />
    </RouterLink>
  )
}

Logo.propTypes = {
  sx: PropTypes.object,
}
